import React,{ Suspense, lazy, useCallback, useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import './App.css';
import axios from './api/axios'
import  { Toaster } from 'react-hot-toast';
import Background from './Components/layout/Background';
import { ThemeProvider } from './Components/layout/ThemeContext';
import { AppPreferencesProvider } from './Components/layout/AppPreferencesContext';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import SideNav from './Components/layout/SideNav';

import { setCompany } from './features/companies';
import { setCategory } from './features/categories';
import { setTasks } from './features/Tasks';


import { CATEGORIES_URL, COMPANIES_URL, GETALLJOB_URL } from './api/ApiUrl';
import SideBar from './Components/layout/SideBar';

import Notifications from './Notifications/Notifications';

import PageLoader from './Components/loaders/PageLoader';

const Login = lazy(()=>import('./Components/pages/Login'));
const Welcome = lazy(()=>import('./Components/pages/Welcome'));
const Register = lazy(()=>import('./Components/pages/Register'));
const ForgotPassword = lazy(()=>import('./Components/pages/ForgotPassword'));
const Profile = lazy(()=>import('./Components/pages/Profile'));
const Settings = lazy(()=>import('./Components/pages/Settings'));
const CreateCategory = lazy(()=>import('./Components/Category/CreateCategory'));
const CategoryTasks = lazy(()=>import('./Components/pages/CategoryTasks'));
const EditCategory = lazy(()=>import('./Components/Category/EditCategory'));
const CompanyTasks = lazy(()=>import('./Components/pages/CompanyTasks'));
const MyTasks = lazy(()=>import('./Components/pages/MyTasks'));
const DoneTasks = lazy(()=>import('./Components/pages/DoneTasks'));
const PinnedTasks = lazy(()=>import('./Components/pages/PinnedTasks'));
const Analytics = lazy(()=>import('./Components/pages/Analytics'));
const PasswordReset = lazy(()=>import('./Components/pages/PasswordReset'));

function App() {
  const dispatch = useDispatch();
  const user=useSelector((state)=>state.user.value);
  const userId = user?.id;
  const [bootLoading, setBootLoading]=useState(false);
  const ProtectedRoute=({user, children})=>{
    if(user==null){
      return <Navigate to='/' replace/>
    }
    return children;
  }

  function Redirect({to}){
    let Navigate=useNavigate();
    useEffect(()=>{
      Navigate(to)
    });
    return null;
  }

  const getCompany=useCallback(async()=>{
   
      if(!userId) return;
      const res=await axios.get(`${COMPANIES_URL}${userId}`)
      dispatch(setCompany(res.data.companies))
    
  }, [dispatch, userId])
  const getCategories= useCallback(async()=>{
   
      if(!userId) return;
      const res= await axios.get(`${CATEGORIES_URL}${userId}`)
      dispatch(setCategory(res.data.categories));
    
  }, [dispatch, userId])

  const getAllJobs=useCallback(async()=>{
      if(!userId) return;
      const res=await axios.get(`${GETALLJOB_URL}${userId}`)
      dispatch(setTasks(res.data))
  }, [dispatch, userId])


  useEffect(()=>{
    if(userId){
      setBootLoading(true);
      Promise.all([getCompany(), getCategories(), getAllJobs()]).finally(()=>setBootLoading(false));
    }
  },[getAllJobs, getCategories, getCompany, userId])

  return (
    <Background>
        {user!=null && <Notifications getCompany={getCompany} getCategories={getCategories} getAllJobs={getAllJobs}/> }

      <ThemeProvider>
      <AppPreferencesProvider>
        {user!=null?
        <SideNav/>
        :
        null}

      {bootLoading && <div className='app-sync-indicator'>Syncing latest data</div>}
      <Suspense fallback={<PageLoader title="Loading page" />}>
      <Routes>
            <Route exact path='/doneTasks' element={<ProtectedRoute user={user}><DoneTasks/> </ProtectedRoute>}/>
            <Route exact path='/pinnedTasks' element={<ProtectedRoute user={user}><PinnedTasks/> </ProtectedRoute>}/>
            <Route exact path='/analytics' element={<ProtectedRoute user={user}><Analytics/> </ProtectedRoute>}/>
            <Route exact path='/company/:compId' element={<ProtectedRoute user={user}><CompanyTasks/> </ProtectedRoute>}/>
            <Route exact path='/category/:compId/:catId/:activeJob' element={<ProtectedRoute user={user}><CategoryTasks/></ProtectedRoute>}/>
            <Route exact path='/category/:compId/:catId' element={<ProtectedRoute user={user}><CategoryTasks/></ProtectedRoute>}/>
            <Route exact path='/category/edit/:catId' element={<ProtectedRoute user={user}> <EditCategory/> </ProtectedRoute>}/>
            <Route exact path='/create/category' element={<ProtectedRoute user={user}><CreateCategory/></ProtectedRoute>}/>
            <Route exact path='/myTasks' element={<ProtectedRoute user={user}> <MyTasks/></ProtectedRoute>}/>
            <Route exact path='/settings' element={<ProtectedRoute user={user}><Settings/></ProtectedRoute>} /> 
            <Route exact path='/profile' element={<ProtectedRoute user={user}> <Profile/></ProtectedRoute>}/>
            <Route exact path='/profile/:compId' element={<ProtectedRoute user={user}> <Profile/></ProtectedRoute>}/>
            <Route exact path='/signUp' element={user!=null? <Redirect to='/myTasks'/>:<Register/>}/>
            <Route exact path='/passwordReset/:token' element={user!=null? <Redirect to='/myTasks'/>:<PasswordReset/> } />
            <Route exact path='/forgot-password' element={user!=null? <Redirect to='/myTasks'/>:<ForgotPassword/> }/>
            <Route exact path="/login" element= {user!=null? <Redirect to='/myTasks'/>:<Login/>}/>
            <Route exact path="/" element= {user!=null? <Redirect to='/myTasks'/>:<Welcome/>}/>
      </Routes>
      </Suspense>
      {user!=null?
        <SideBar/>
        :
        null}
      </AppPreferencesProvider>
      </ThemeProvider>
      <Toaster toastOptions={{className: 'escapeToaster'}} /> 
    </Background>
  );
}

export default App;
